import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiline'
})
export class MultilinePipe implements PipeTransform {


  //by word
  transform(value: string, nbWordsPerLine: number)
  {
    if(typeof value != 'string') return [value];

    let words = value.split(' ');
    let nbWords = words.length;
    let multiline = [];
    let phrase = [];
    let wp = 1;

    for(let w=0; w<nbWords; w++) {
      phrase.push(words[w]);
      if(wp==nbWordsPerLine
      || w==nbWords-1) {
        multiline.push( phrase.join(' ') );
        phrase = [];
        wp = 1;
      }
      wp++;
    }

    return multiline.join("\n");
  }

}
